import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-fcd2c342"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loginBG" }
const _hoisted_2 = { class: "d-flex flex-column justify-content-start align-items-center mb-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "box-logo mt-3 mb-3",
  src: _imports_0,
  alt: "Logo"
}, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_5 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_card, {
        class: "box-card",
        shadow: "hover",
        "body-style": _ctx.singinInputCardStyle
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_el_form, {
              onSubmit: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"])),
              model: _ctx.loginData,
              rules: _ctx.loginFormRules,
              ref: "loginForm"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { prop: "username" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "w-100",
                      modelValue: _ctx.loginData.username,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginData.username) = $event)),
                      placeholder: _ctx.t('username'),
                      "prefix-icon": _ctx.User,
                      onKeydown: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onKeydown())),
                      onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.onSigninClicked()), ["enter"])),
                      tabindex: "1"
                    }, null, 8, ["modelValue", "placeholder", "prefix-icon"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { prop: "password" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "w-100",
                      modelValue: _ctx.loginData.password,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loginData.password) = $event)),
                      placeholder: _ctx.t('password'),
                      "show-password": "",
                      "prefix-icon": _ctx.Lock,
                      onKeydown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onKeydown())),
                      onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.onSigninClicked()), ["enter"])),
                      tabindex: "2"
                    }, null, 8, ["modelValue", "placeholder", "prefix-icon"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      class: "w-100",
                      modelValue: _ctx.loginData.locale,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.loginData.locale) = $event)),
                      onChange: _ctx.onLangSelectChanged,
                      placeholder: _ctx.t('select_language')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          value: "en_us",
                          label: "English"
                        }),
                        _createVNode(_component_el_option, {
                          value: "zh_tw",
                          label: "繁體中文"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange", "placeholder"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, {
                      modelValue: _ctx.loginData.isKeepLogin,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.loginData.isKeepLogin) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("Remember_me")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  class: "w-100",
                  type: "primary",
                  plain: "",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onSigninClicked())),
                  loading: _ctx.isSigninBtnLoading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.isSigninBtnLoading ? _ctx.t("processing") : _ctx.t("login")), 1)
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_el_button, {
                  class: "w-100",
                  type: "primary",
                  text: "忘記密碼",
                  plain: "",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onPasswordClicked())),
                  loading: _ctx.isSigninBtnLoading,
                  style: {"margin-left":"0","margin-top":"5px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('PasswordForget')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            }, 8, ["model", "rules"]),
            (_ctx.isShowErrorMsg)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.t('wrong_password')), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["body-style"])
    ]),
    _createVNode(_component_el_dialog, {
      class: "dialog",
      modelValue: _ctx.isShowPasswordDialog,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.isShowPasswordDialog) = $event)),
      title: _ctx.t('PasswordForget')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, {
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isShowPasswordDialog = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.submitNewPasswordForm()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-width": "100px",
          ref: "passwordForm",
          rules: _ctx.passwordRules,
          model: _ctx.passwordFormData
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.t('username'),
              prop: "username"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"90%"},
                  modelValue: _ctx.passwordFormData.username,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.passwordFormData.username) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}